import { createFileRoute } from '@tanstack/react-router'
import { TrackerListView } from '@/features/tracker/TrackerListView'
import { AdminGuard } from '@/components/admin-guard'

export const Route = createFileRoute('/admin/tracker')({
  component: () => (
    <AdminGuard>
      <TrackerListView admin />
    </AdminGuard>
  ),
})
